import { render, staticRenderFns } from "./Families.vue?vue&type=template&id=6f605768"
import script from "./Families.vue?vue&type=script&lang=js"
export * from "./Families.vue?vue&type=script&lang=js"
import style0 from "./Families.vue?vue&type=style&index=0&id=6f605768&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports